module.exports = __webpack_public_path__ + "static/media/fir_ext_car_dio.b4966fb1.png";